"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGridLegacyResponsiveExampleCodeSegments = exports.GKDataGridLegacyResponsiveExample = void 0;
var React = __importStar(require("react"));
var gds_ux_components_1 = require("@granular/gds-ux-components");
var hooks_1 = require("@granular/gds-ux-components/lib/common/hooks");
var components_1 = require("../../components");
var myData = __spreadArray([], Array(30), true).map(function (d, i) { return ({
    acres: ~~(Math.random() * 120) + 3 * i,
    crop: ["Corn", "Soybeans", "Wheat", "Sorghum"][~~(Math.random() * 4)],
    id: i,
    farmName: "Test Farm Name #:" + ((i % 3) + 1),
    fieldName: "Test Field Name #" + (i + 1),
}); });
var allCols = {
    farm: {
        accessor: "farmName",
        Header: "Farm",
        minWidth: 150,
    },
    field: {
        accessor: "fieldName",
        Header: "Field",
        minWidth: 150,
    },
    acres: {
        accessor: "acres",
        Header: "Acres",
        minWidth: 80,
    },
    crop: {
        accessor: "crop",
        Header: "Crop",
        minWidth: 125,
    },
};
var responsiveCols = {
    xs: [allCols.field, allCols.acres],
    md: [allCols.field, allCols.crop, allCols.acres],
    lg: [allCols.farm, allCols.field, allCols.crop, allCols.acres],
};
var switchToCards = {
    xs: true,
    lg: false,
};
var renderCard = function (d) { return (React.createElement(gds_ux_components_1.GKCard, { key: d.id, className: "m-2 flex-fill" },
    React.createElement(gds_ux_components_1.GKCardHeader, null,
        React.createElement(gds_ux_components_1.GKCardTitle, { className: "my-0" }, d.fieldName)),
    React.createElement(gds_ux_components_1.GKCardBody, null,
        React.createElement("p", { className: "my-0" },
            React.createElement("strong", null, "Farm:"),
            " ",
            d.farmName),
        React.createElement("p", { className: "my-1" },
            React.createElement("strong", null, "Acres:"),
            " ",
            d.acres),
        React.createElement("p", { className: "my-0" },
            React.createElement("strong", null, "Crop:"),
            " ",
            d.crop)))); };
var GKDataGridLegacyResponsiveExample = function () {
    var _a = React.useState(false), useResponsiveCols = _a[0], setUseResponsiveCols = _a[1];
    var _b = React.useState(false), useCard = _b[0], setUseCard = _b[1];
    var _c = React.useState(false), atCardSize = _c[0], setAtCardSize = _c[1];
    (0, hooks_1.useResponsive)(switchToCards, setAtCardSize);
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("h3", null, "Responsive setting:"),
            React.createElement(gds_ux_components_1.GKRadio, { name: "responsiveSetting", label: "Scroll horizontally (default)", checked: !useResponsiveCols && !useCard, onChange: function (e) {
                    return e.target.checked && (setUseCard(false), setUseResponsiveCols(false));
                } }),
            React.createElement(gds_ux_components_1.GKRadio, { name: "responsiveSetting", label: "Use responsive columns", checked: useResponsiveCols, onChange: function (e) {
                    return e.target.checked && (setUseCard(false), setUseResponsiveCols(true));
                } }),
            React.createElement(gds_ux_components_1.GKRadio, { name: "responsiveSetting", label: "Transform table to GKCards (at under 992px screen width)", checked: useCard, onChange: function (e) {
                    return e.target.checked && (setUseCard(true), setUseResponsiveCols(false));
                } })),
        React.createElement(components_1.GKDataGridLegacy, { columns: useResponsiveCols ? responsiveCols : Object.values(allCols), data: myData, gridStyle: { height: 300 } }, function (state, makeTable) {
            if (useCard && atCardSize) {
                return (React.createElement("div", { className: "d-flex flex-wrap" }, state.resolvedData.map(renderCard)));
            }
            return makeTable();
        })));
};
exports.GKDataGridLegacyResponsiveExample = GKDataGridLegacyResponsiveExample;
// </copy>
// AUTOGENERATED:
/* eslint-disable prettier/prettier */
exports.GKDataGridLegacyResponsiveExampleCodeSegments = ["interface ITestDatum {\n  acres: number;\n  crop: string;\n  id: number;\n  farmName: string;\n  fieldName: string;\n}\nconst myData: ITestDatum[] = [...Array(30)].map((d, i) => ({\n  acres: ~~(Math.random() * 120) + 3 * i,\n  crop: [\"Corn\", \"Soybeans\", \"Wheat\", \"Sorghum\"][~~(Math.random() * 4)],\n  id: i,\n  farmName: \"Test Farm Name #:\" + ((i % 3) + 1),\n  fieldName: \"Test Field Name #\" + (i + 1),\n}));\nconst allCols: { [col: string]: Column<any> } = {\n  farm: {\n    accessor: \"farmName\",\n    Header: \"Farm\",\n    minWidth: 150,\n  },\n  field: {\n    accessor: \"fieldName\",\n    Header: \"Field\",\n    minWidth: 150,\n  },\n  acres: {\n    accessor: \"acres\",\n    Header: \"Acres\",\n    minWidth: 80,\n  },\n  crop: {\n    accessor: \"crop\",\n    Header: \"Crop\",\n    minWidth: 125,\n  },\n};\nconst responsiveCols: Responsive<Column<any>[]> = {\n  xs: [allCols.field, allCols.acres],\n  md: [allCols.field, allCols.crop, allCols.acres],\n  lg: [allCols.farm, allCols.field, allCols.crop, allCols.acres],\n};\nconst switchToCards: Responsive<boolean> = {\n  xs: true,\n  lg: false,\n};\nconst renderCard: React.FC<GKDataGridDataObject<ITestDatum>> = (d) => (\n  <GKCard key={d.id} className=\"m-2 flex-fill\">\n    <GKCardHeader>\n      <GKCardTitle className=\"my-0\">{d.fieldName}</GKCardTitle>\n    </GKCardHeader>\n    <GKCardBody>\n      <p className=\"my-0\">\n        <strong>Farm:</strong> {d.farmName}\n      </p>\n      <p className=\"my-1\">\n        <strong>Acres:</strong> {d.acres}\n      </p>\n      <p className=\"my-0\">\n        <strong>Crop:</strong> {d.crop}\n      </p>\n    </GKCardBody>\n  </GKCard>\n);\nexport const GKDataGridLegacyResponsiveExample: React.FC = () => {\n  const [useResponsiveCols, setUseResponsiveCols] = React.useState(false);\n  const [useCard, setUseCard] = React.useState(false);\n  const [atCardSize, setAtCardSize] = React.useState(false);\n  useResponsive(switchToCards, setAtCardSize);\n  return (\n    <div>\n      <div>\n        <h3>Responsive setting:</h3>\n        <GKRadio\n          name=\"responsiveSetting\"\n          label=\"Scroll horizontally (default)\"\n          checked={!useResponsiveCols && !useCard}\n          onChange={(e): false | void =>\n            e.target.checked && (setUseCard(false), setUseResponsiveCols(false))\n          }\n        />\n        <GKRadio\n          name=\"responsiveSetting\"\n          label=\"Use responsive columns\"\n          checked={useResponsiveCols}\n          onChange={(e): false | void =>\n            e.target.checked && (setUseCard(false), setUseResponsiveCols(true))\n          }\n        />\n        <GKRadio\n          name=\"responsiveSetting\"\n          label=\"Transform table to GKCards (at under 992px screen width)\"\n          checked={useCard}\n          onChange={(e): false | void =>\n            e.target.checked && (setUseCard(true), setUseResponsiveCols(false))\n          }\n        />\n      </div>\n      <GKDataGridLegacy\n        columns={useResponsiveCols ? responsiveCols : Object.values(allCols)}\n        data={myData}\n        gridStyle={{ height: 300 }}\n      >\n        {(\n          state: FinalState,\n          makeTable: () => React.ReactElement\n        ): JSX.Element => {\n          if (useCard && atCardSize) {\n            return (\n              <div className=\"d-flex flex-wrap\">\n                {state.resolvedData.map(renderCard)}\n              </div>\n            );\n          }\n          return makeTable();\n        }}\n      </GKDataGridLegacy>\n    </div>\n  );\n};"];
/* eslint-enable prettier/prettier */
